import { createIntlCache } from 'react-intl';
import { createIntl as createIntlWithCache } from 'react-intl/src/components/createIntl';
import { createObject } from '@frameio/basics/object';
import { handleIntlError } from './errors';
import { type IntlConfig, type IntlShape } from './types';

const CACHE = createIntlCache();

export function createIntl(config: IntlConfig): IntlShape {
  const base = createIntlWithCache(
    { onError: handleIntlError, ...config },
    CACHE
  );
  return createObject(base, {
    get config(): IntlConfig {
      return config;
    },
  });
}
